import { useState } from 'react';

export default function ZoomController() {
  const [zoom, setZoom] = useState(16);
  const updateZoom = (newZoom) => {
    setZoom(newZoom);
    return newZoom;
  };

  return { zoom, updateZoom }
}
